export default __webpack_public_path__ + "static/howflowworks-590a8c012cf1c3948a664d2769de1dcd.png";